import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { AppSettingsConfig, AppSettingsState, TAKE_NAEP_NOW_URL_DEFAULT } from './models';

const selectAppSettingsState = (state: RootState): AppSettingsState => state.appSettings;

export const selectAppSettings = createSelector(
  [selectAppSettingsState],
  (state: AppSettingsState) => state ? state.appSettings : null
);

export const selectMaxNumItemsPerCustomTest = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null): number => state ? state.maxNumItemsPerCustomTest : 200
);

export const selectMaxNumItemsPerExcelDownload = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null): number => state ? state.maxNumItemsPerExcelDownload : 20
);

export const selectShareFacebookUrl = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null): string => state ? state.shareFacebookUrl : ''
);

export const selectShareTwitterUrl = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null): string => state ? state.shareTwitterUrl : ''
);

export const selectShareEmail = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null): string => state ? state.shareEmail : ''
);

export const selectGoogleAnalyticsTrackingId = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null): string => state ? state.googleAnalyticsTrackingId : ''
);

export const selectMaxTestTakersPerCustomTest = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null): number => state ? state.maxTestTakersPerCustomTest : 200
);

export const selectMaxNumItemsPerHTMLDownload = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null) => state ? state.maxNumItemsPerHTMLDownload : 150
);

export const selectTakeNAEPNowURL = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null) => state ? state.takeNAEPNowURL : TAKE_NAEP_NOW_URL_DEFAULT
);

export const selectTestLaunchURL = createSelector(
  [selectAppSettings],
  (state: AppSettingsConfig|null) => state ? state.testLaunchURL : ''
);

export const selectControlsLoading = createSelector(
  [selectAppSettingsState],
  (state: AppSettingsState) => state ? state.loading : null
);

export const selectControlsloaded = createSelector(
  [selectAppSettingsState],
  (state: AppSettingsState) => state ? state.loaded : null
);

export const selectControlsErrMsg = createSelector(
  [selectAppSettingsState],
  (state: AppSettingsState) => state ? state.errMsg : null
);